import { render, staticRenderFns } from "./ProjectMsgSet.vue?vue&type=template&id=1ef3b5f4&scoped=true&"
import script from "./ProjectMsgSet.vue?vue&type=script&lang=js&"
export * from "./ProjectMsgSet.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMsgSet.vue?vue&type=style&index=0&id=1ef3b5f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3b5f4",
  null
  
)

export default component.exports